// extracted by mini-css-extract-plugin
module.exports = {"Container":"Appointment_Container__3ouYg","Wrapper":"Appointment_Wrapper__dydzj","ContainerLoader":"Appointment_ContainerLoader__1XecX"};